import { degreesToMeters, metersToDegrees } from '../../../utils/Geotile'

/**
 * Draws a rectangle, where top/bottom are fixed to lines of latitude and sides are fixed to lines of lng. 
 * Used when we need a canonical NW corner to calculate rotation.
 * Heavily modified from:
 * @author geostarters
 * @see {@link https://github.com/geostarters/mapbox-gl-draw-assisted-rectangle-mode}
 */
function init( options ) {
  return {
    onSetup( opts ) {
      const rectangle = this.newFeature( {
        type : 'Feature',
        properties : {},
        geometry : {
          type : 'Polygon',
          coordinates : [
            []
          ]
        }
      } )
      this.addFeature( rectangle )
  
      this.clearSelectedFeatures()
      return {
        rectangle,
        currentVertexPosition : 0
      }
    },
  
    onClick( state, e ) {
      if ( state.currentVertexPosition === 2 ) {
  
        const getpXY3 = this.calculatepXY3( state, e, false )
  
        if ( getpXY3 ) {
          state.rectangle.updateCoordinate( `0.${state.currentVertexPosition + 1}`, getpXY3[0], getpXY3[1] )
        }
        return this.changeMode( 'simple_select', {
          featuresId : state.rectangle.id
        } )
      } if ( state.currentVertexPosition === 1 ) {
        const fixedLat = state.rectangle.getCoordinate( '0.0' )[1]
        state.rectangle.updateCoordinate( `0.${state.currentVertexPosition}`, e.lngLat.lng, fixedLat )
      } else { 
        state.rectangle.updateCoordinate( `0.${state.currentVertexPosition}`, e.lngLat.lng, e.lngLat.lat )
      }
      state.currentVertexPosition++
      state.rectangle.updateCoordinate( `0.${state.currentVertexPosition}`, e.lngLat.lng, e.lngLat.lat )
    },
  
    onMouseMove( state, e ) {
      if ( state.currentVertexPosition && state.currentVertexPosition === 1 ) {
        const fixedLat = state.rectangle.getCoordinate( '0.0' )[1]
        state.rectangle.updateCoordinate( `0.${state.currentVertexPosition}`, e.lngLat.lng, fixedLat )
      } else {
        state.rectangle.updateCoordinate( `0.${state.currentVertexPosition}`, e.lngLat.lng, e.lngLat.lat )
      }
      
      if ( state.currentVertexPosition ) {
  
        if ( state.currentVertexPosition > 0 ) {
          this.calculateOrientedAnglePolygon( state )
        }
  
        if ( state.currentVertexPosition === 2 ) {
          const getpXY3 = this.calculatepXY3( state, e, true )
    
          if ( getpXY3 ) {
            state.rectangle.updateCoordinate( `0.${state.currentVertexPosition + 1}`, getpXY3[0], getpXY3[1] )
          }
        }
      }
    },
  
    calculateOrientedAnglePolygon( state ) {
      const pXY0 = state.rectangle.getCoordinate( '0.0' )
      const pXY0_3857 = degreesToMeters( pXY0 )
      const pXY1 = state.rectangle.getCoordinate( '0.1' )
      const pXY1_3857 = degreesToMeters( pXY1 )
      const angleStdGraus = Math.atan2( pXY1_3857[1] - pXY0_3857[1], pXY1_3857[0] - pXY0_3857[0] ) * 180 / Math.PI
  
      const angleSudGraus = -1.0 * ( angleStdGraus + 90 )
      const angle = angleSudGraus < 0 ? angleSudGraus + 360 : angleSudGraus
  
      state.angle = parseFloat( ( angle ).toFixed( 2 ) )
  
    },
  
    calculatepXY3( state, e, tmp ) {
  
      const pXY0 = state.rectangle.getCoordinate( '0.0' )
      const pXY0_3857 = degreesToMeters( pXY0 )
      const pXY1 = state.rectangle.getCoordinate( '0.1' )
      const pXY1_3857 = degreesToMeters( pXY1 )
      let pXY2_3857 = degreesToMeters( [ e.lngLat.lng, e.lngLat.lat ] )
      const mouse_3857 = degreesToMeters( [ e.lngLat.lng, e.lngLat.lat ] )
      if ( pXY0_3857[0] === pXY1_3857[0] ) {
        pXY2_3857 = [ mouse_3857[0], pXY1_3857[1] ]
      } else if ( pXY0_3857[1] === pXY1_3857[1] ) {
        pXY2_3857 = [ pXY1_3857[0], mouse_3857[1] ]
  
      } else {
  
        const vector1_3857 = ( pXY1_3857[1] - pXY0_3857[1] ) / ( pXY1_3857[0] - pXY0_3857[0] )
        const vector2_3857 = -1.0 / vector1_3857
  
        if ( Math.abs( vector2_3857 ) < 1 ) {
          pXY2_3857[1] = vector2_3857 * ( mouse_3857[0] - pXY1_3857[0] ) + pXY1_3857[1]
        } else {
          pXY2_3857[0] = pXY1_3857[0] + ( pXY2_3857[1] - pXY1_3857[1] ) / vector2_3857
        }
      }
  
      const vector_3857 = [ pXY1_3857[0] - pXY0_3857[0], pXY1_3857[1] - pXY0_3857[1] ]
      const pXY3_3857 = [ pXY2_3857[0] - vector_3857[0], pXY2_3857[1] - vector_3857[1] ]
      const pXY2G = metersToDegrees( pXY2_3857 )
      const pXY3G = metersToDegrees( pXY3_3857 )
      // state.rectangle.updateCoordinate("0.2", pXY2G[0], pXY2G[1])
      // state.rectangle.updateCoordinate("0.3", pXY3G[0], pXY3G[1])
      state.rectangle.updateCoordinate( '0.2', pXY1[0], e.lngLat.lat )
      state.rectangle.updateCoordinate( '0.3', pXY0[0], e.lngLat.lat )
      return pXY3G
    },
  
    onKeyUp( state, e ) {
      if ( e.keyCode === 27 ) {
        this.onTrash( state )
        return this.changeMode( 'simple_select' )
      }
    },
  
    onStop( state ) {
      this.updateUIClasses( {
        mouse : 'none'
      } )
      this.activateUIButton()
  
      // check to see if we've deleted this feature
      if ( this.getFeature( state.rectangle.id ) === undefined ) return
  
      // remove last added coordinate
      state.rectangle.removeCoordinate( '0.4' )
  
      if ( state.rectangle.isValid() ) {
        const orderedCoordinates = this.getOrderedCoordinates( state )
        const geoJson = state.rectangle.toGeoJSON()
        this.map.fire( 'draw.create', {
          features : [ {
            ...geoJson,
            geometry : {
              ...geoJson.geometry,
              coordinates : orderedCoordinates
            }
          } ]
        } )
  
      } else {
        this.deleteFeature( [ state.rectangle.id ], {
          silent : true
        } )
        this.changeMode( 'simple_select', {}, {
          silent : false
        } )
      }
    },
  
    /**
     * orders coordinates so that coord[0] is always the NW corner, proceeding clockwise from there
     */
    getOrderedCoordinates( state ) {
      const originalCoordinates = []
      for ( let i = 0; i < 4; i++ ) {
        originalCoordinates.push( state.rectangle.getCoordinate( `0.${i}` ) )
      } 
  
      // sort by latitude
      const tempSort = [ ...originalCoordinates ].sort( ( a, b ) => b[1] - a[1] )
      // sort top E-W
      const top = tempSort.slice( 0, 2 ).sort( ( a, b ) => a[0] - b[0] )
      // sort bottom W-E
      const bot = tempSort.slice( 2 ).sort( ( a, b ) => b[0] - a[0] )
      
      const sortedCoordinates = [ ...top, ...bot, top[0] ]
  
      for ( let i = 0; i < 4; i++ ) {
        state.rectangle.updateCoordinate( `0.${i}`, sortedCoordinates[i][0], sortedCoordinates[i][1] )
      }
      return [ sortedCoordinates ]
    },
  
    toDisplayFeatures( state, geojson, display ) {
      const isActivePolygon = geojson.properties.id === state.rectangle.id
      geojson.properties.active = isActivePolygon ? 'true' : 'false'
      geojson.properties.angle = state.angle
      geojson.angle = state.angle
      if ( !isActivePolygon ) return display( geojson )
  
      const coordinateCount = geojson.geometry.coordinates[0].length
  
      if ( coordinateCount < 3 ) {
  
        const coordinates = geojson.geometry.coordinates[0][0]
  
        const vertexPoint = {
          type : 'Feature',
          properties : geojson.properties,
          angle : state.angle,
          geometry : {
            coordinates : geojson.geometry.coordinates[0][0],
            type : 'Point'
          }
        }
  
        if ( coordinates ) {
          display( vertexPoint )
        }
  
        return
      }
      if ( coordinateCount >= 3 && coordinateCount <= 4 ) {
  
        const lineCoordinates = [
          [ geojson.geometry.coordinates[0][0][0], geojson.geometry.coordinates[0][0][1] ],
          [ geojson.geometry.coordinates[0][1][0], geojson.geometry.coordinates[0][1][1] ]
        ]
  
        display( {
          type : 'Feature',
          properties : geojson.properties,
          angle : state.angle,
          geometry : {
            coordinates : lineCoordinates,
            type : 'LineString'
          }
        } )
        if ( coordinateCount === 3 ) {
          return
        }
      }
  
      return display( geojson )
    }
  }
}

exports.init = init
